import { render, staticRenderFns } from "./Kinesitherapies.vue?vue&type=template&id=d9472afa&scoped=true"
import script from "./Kinesitherapies.vue?vue&type=script&lang=js"
export * from "./Kinesitherapies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9472afa",
  null
  
)

export default component.exports